<template lang="pug">
	div
		a(v-if="params.data.projId >= 10000" @click="showProject(params.data)") Copy
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
	name: 'ag-grid-clone-project',
	data () {
		return {
			project: {},
			userId: ''
		}
	},
	methods: {
		showProject (wichProject) {
			let project = wichProject
			Vue.e24.projectService
				.clone(project.userId, project.projId)
				.then(addedPrj => {
					const gotoProject = {
						name: 'project.takeoff',
						params: {
							id: addedPrj.projId
						}
					}
					this.$router.push(gotoProject)
				})
				.catch(error => {
					if (error) {
						console.error('Clone method error: ' + JSON.stringify(error.errors))
					}
				})
		}
	}
})
</script>



// WEBPACK FOOTER //
// src/app/project/ag-grid/clone-project.vue